import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { AppSettingsService, DeferLoadDirective, IconCircleComponent, SvgIconComponent } from '@woolworthsnz/styleguide';
import { Stamp } from '../../models/stamp.interface';
import { NgIf, NgTemplateOutlet, NgClass } from '@angular/common';

@Component({
	selector: 'recipe-meal-plan-shortlist-meal',
	templateUrl: './meal-plan-shortlist-meal.component.html',
	styleUrls: ['./meal-plan-shortlist-meal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [DeferLoadDirective, NgIf, NgTemplateOutlet, NgClass, SvgIconComponent, IconCircleComponent]
})
export class MealPlanShortlistMealComponent {
	@Input() meal: Stamp;
	@Input() imageUrl: string;
	@Input() showDetails: boolean;
	@Input() isNarrowView: boolean;

	@Output() remove = new EventEmitter<Stamp>();

	public imageLoading = true;

	constructor(private appSettingsService: AppSettingsService) { }

	@HostBinding('attr.isExpanded')
	get isExpanded(): boolean {
		return this.showDetails;
	}

	get fallbackImageUrl(): string {
		return `/images/recipe_unavailable.svg`;
	}

	public removeMeal(stamp: Stamp): void {
		this.remove.emit(stamp);
	}

	public truncateText(text: string): string {
		const limit = 24;
		return text.length > limit ? `${text.slice(0, limit)}...` : text;
	}
}
